import React, { useState, useEffect } from 'react';

import Modal from '../shared/modal';
import TextInput from '../shared/TextInput';
import ColorButton from '../shared/ColorButton';
// import SelectBox from '../shared/select/SelectBox';

// import { pipelineTypes } from '../../constants/sales'

// const pipelineTypeOptions = [
//   { label: pipelineTypes.LEAD.label, value: pipelineTypes.LEAD.value },
//   { label: pipelineTypes.ACTIVE.label, value: pipelineTypes.ACTIVE.value },
// ];

const CreatePipelineModal = ({ pipeline, open, onClose, onSubmit, loading, mode = 'create' }) => {
  const [title, setTile] = useState(pipeline?.title || '');
  // const [type, setType] = useState(pipeline?.type || pipelineTypes.LEAD.value);

  useEffect(() => {
    if (mode === 'update' && open && pipeline) {
      setTile(pipeline?.title || '');
      // setType(pipeline?.type || pipelineTypes.LEAD.value);
    }
  }, [mode, open, pipeline]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={mode === 'update' && pipeline ? `Edit ${pipeline.title}` : 'Create New Pipeline'}
      className='create-pipeline-modal__container'
    >
      <div className='create-pipeline-modal__content'>
        <div>
          <div className='secondary m-b-sm'>Pipeline Title</div>
          <TextInput
            value={title}
            onChange={(e) => setTile(e.target.value)}
            placeholder='Type title here'
          />
        </div>

        {/*<div className='m-t-md'>*/}
        {/*  <div className='secondary m-b-sm'>Pipeline Type</div>*/}

        {/*  <SelectBox*/}
        {/*    value={type}*/}
        {/*    onChange={setType}*/}
        {/*    options={pipelineTypeOptions}*/}
        {/*  />*/}
        {/*</div>*/}

        <div className='d-flex flex-end m-t-lg'>
          <div className='m-r-lg'>
            <ColorButton
              color='grey'
              text='Cancel'
              onClick={onClose}
            />
          </div>
          <ColorButton
            color='blue'
            text={mode === 'update' ? 'Save Changes' : 'Submit'}
            onClick={() => {
              if (mode === 'update' && pipeline) {
                onSubmit(pipeline.id, title);
              } else {
                onSubmit(title);
              }
            }}
            disabled={loading || !title}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  )
};

export default CreatePipelineModal;
